import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import DashBoardLeftPanel from "../components/DashBoardLeftPanel";
import DashBoardMiddle from "../components/DashBoardMiddle";
import DashBoardRight from "../components/DashBoardRight";
import { useDispatch, useSelector } from "react-redux";
import CompletedTestsPage from './CompletedTestsPage'
import LeaderboardPage from './LeaderboardPage'
import styled from "styled-components";
import { clearAnswers } from "../slices/answerSlice";

const DashBoard = () => {
  const [currentItem, setCurrentItem] = useState('dashboard');

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearAnswers())
  }, []);

  
  return (
    <div>
      <Navbar />
      <ContentBox>
        <DashBoardLeftPanel currentItem={currentItem} setCurrentItem={setCurrentItem} />
        <DashboardContent>
          {currentItem === 'dashboard' && <DashboardRight>
            <DashBoardMiddle />
            <DashBoardRight />
          </DashboardRight>}
          {currentItem === 'completedTests' && <CompletedTestsPage />}
          {currentItem === 'leaderboard' && <LeaderboardPage />}
        </DashboardContent>
      </ContentBox>
    </div>
  );
};

export default DashBoard;


const DashboardContent = styled.div`
display: flex;
margin-left: 19vw;
max-width: calc(100vw - 19vw);

`

const DashboardRight = styled.div`
  display: grid;
  grid-template-columns: 2.6fr 3.4fr;
  grid-template-rows: 1fr 1fr;
  width: 100%;
  margin-right: 1vw;
  min-height: calc(100vh - 70px);
  row-gap: 0vw;
  column-gap: 1.5vw;

`

const ContentBox = styled.div`
  width: 98%;
  margin-top: 70px;
  z-index: -10000000;


`